import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LegalPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const [content, setContent] = useState({ title: "", body: "" });

  useEffect(() => {
    axios.get(`${API}/content/${slug}`).then(({ data }) => setContent(data)).catch(() => {});
  }, [slug]);

  const blocks = (content.body || "").split(/\n\n+/).filter(Boolean);
  const isHeading = (line) => /^\d+\.\s+\S/.test(line.trim());

  return (
    <div className="min-h-screen bg-[#0E0F12] px-6 py-16">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-gray-400 hover:text-[#3DDC97]">
          <ArrowLeft size={16} /> Zurück
        </Link>
        <h1 className="font-display text-3xl font-bold text-white md:text-4xl" data-testid="legal-title">
          {content.title}
        </h1>
        <div className="mt-8 space-y-5" data-testid="legal-body">
          {blocks.map((block, i) => {
            const lines = block.split("\n");
            if (isHeading(lines[0])) {
              return (
                <div key={i}>
                  <h2 className="font-display text-lg text-[#3DDC97] md:text-xl">{lines[0]}</h2>
                  {lines.length > 1 && (
                    <p className="mt-2 whitespace-pre-line text-[15px] leading-relaxed text-gray-300">
                      {lines.slice(1).join("\n")}
                    </p>
                  )}
                </div>
              );
            }
            return (
              <p key={i} className="whitespace-pre-line text-[15px] leading-relaxed text-gray-300">
                {block}
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
}
